<template>
  <div class="archive-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('global.archiveManagement') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="archiveShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'ArchiveHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            archiveShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.archiveTitle'),
                    tableElements: [
                        {
                            action: this.$t('-'),
                            shortcuts: [
                                { key: '-' }
                            ],
                            voiceCommand: this.$t('-')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
